var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconUiCloseRounded(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 25,
    width: 25,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    fill: "#983794",
    r: 12,
    stroke: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.11 12.5l4.969 5.016-1.52 1.556-4.83-4.874-4.674 4.88-1.476-1.563L11.38 12.5l-4.8-5.015L8.055 5.92l4.675 4.882 4.828-4.873 1.52 1.556z",
    fill: "#fff"
  }))));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-ui--close-rounded-45fb2d5cbbb5ecc4e0c5bf9863abc077.svg";
export { SvgIconUiCloseRounded as Component };